"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamAssetAdjustment = void 0;
var typeorm_1 = require("typeorm");
var Team_entity_1 = require("./Team.entity");
var TeamAssetAdjustment = /** @class */ (function () {
    function TeamAssetAdjustment() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], TeamAssetAdjustment.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], TeamAssetAdjustment.prototype, "assetID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], TeamAssetAdjustment.prototype, "typeID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], TeamAssetAdjustment.prototype, "round", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], TeamAssetAdjustment.prototype, "action", void 0);
    __decorate([
        (0, typeorm_1.ManyToOne)(function () { return Team_entity_1.BaseTeam; }, function (team) { return team.assetAdjustments; }),
        (0, typeorm_1.JoinColumn)({ name: 'teamID' }),
        __metadata("design:type", Team_entity_1.BaseTeam)
    ], TeamAssetAdjustment.prototype, "team", void 0);
    TeamAssetAdjustment = __decorate([
        (0, typeorm_1.Entity)({ name: 'team_asset_adjustment' })
    ], TeamAssetAdjustment);
    return TeamAssetAdjustment;
}());
exports.TeamAssetAdjustment = TeamAssetAdjustment;
//# sourceMappingURL=TeamAssetAdjustment.entity.js.map